(function FormatCurrencyDirective($, Adzuki)
{
    'use strict';

    const vFormatCurrency = {
        mounted(el, binding) {
            updateContent(el, binding.value, binding.modifiers);
        },
        updated(el, binding) {
            updateContent(el, binding.value, binding.modifiers);
        }
    };

    function updateContent(el, value, modifiers) {
        const amount = parseFloat(value);

        if (isNaN(amount)) {
            el.textContent = '';
            return;
        }

        // Check for 'no-decimals' modifier
        const showDecimals = !modifiers['no-decimals'];

        const formatted = new Intl.NumberFormat('en-US', {
            style                : 'currency',
            currency             : 'USD',
            minimumFractionDigits: showDecimals ? 2 : 0,
            maximumFractionDigits: showDecimals ? 2 : 0
        }).format(amount);

        el.textContent = formatted;
    }

    Adzuki.VueDirectives.FormatCurrency = vFormatCurrency;
}(jQuery, window.Adzuki || {}));